import { iconDiscord } from '#src/atoms/icons/system/iconDiscord.ts';
import { OAuthAccount } from '#src/components/settings/OAuthAccount/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const DiscordAccount = () => {
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) return null;

  const { discordUsername } = currentUser.profile;

  return (
    <OAuthAccount
      nickname={discordUsername}
      provider="discord"
      icon={iconDiscord}
    />
  );
};
